module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('gc-order-list-with-acitons', {
    attrs: {
      "orderList": _vm.orderList,
      "show-product-contract-no": false
    },
    on: {
      "goToOrderDetail": _vm.toDetailInfo,
      "downloadOrderText": _vm.handleDownloadOrderText
    },
    scopedSlots: _vm._u([{
      key: "itemButton",
      fn: function(order) {
        return [(_vm.showCancelButton(order)) ? _c('div', {
          staticClass: "return-btn research-font-color",
          on: {
            "click": function($event) {
              return _vm.$emit('cancelOrder', order)
            }
          }
        }, [_vm._v("取消订单")]) : _vm._e(), _vm._v(" "), (_vm.showSubmitOrderButton(order)) ? _c('div', {
          staticClass: "pay-btn research-background-color",
          staticStyle: {
            "margin-left": "10px"
          },
          on: {
            "click": function($event) {
              return _vm.$emit('submitOrder', order)
            }
          }
        }, [_vm._v("提交订单")]) : _vm._e(), _vm._v(" "), (_vm.showSubmitToSignOrderButton(order)) ? _c('div', {
          staticClass: "pay-btn research-background-color",
          staticStyle: {
            "margin-left": "10px"
          },
          on: {
            "click": function($event) {
              return _vm.$emit('submitOrderToSign', order)
            }
          }
        }, [_vm._v("签署合同\n      ")]) : _vm._e()]
      }
    }])
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d1af86c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views_v_2.6/User/myOrders/OrderListPage.vue
// module id = 1558
// module chunks = 8